/**
 * The money a store product can be priced in: the store's supported
 * currencies, as its config says (SUPPORTED_CURRENCIES → store_config, read
 * with useStoreCurrency in ./currency.js). `coins` is the virtual currency
 * and is kept apart: it is priced, but never charged or refunded.
 */
export const VIRTUAL_CURRENCY = "coins"

/** As a dropdown takes them: `[{ value, label }]`, from the store's currencies. */
export const currencyOptions = ({ virtual = false, currencies = [] } = {}) => [
  ...currencies.map((code) => ({ value: code, label: code })),
  ...(virtual ? [{ value: VIRTUAL_CURRENCY, label: VIRTUAL_CURRENCY.toUpperCase() }] : []),
]
